import React, {useState, forwardRef} from 'react';
import {makeStyles} from 'tss-react/mui';
import Grid from '@mui/material/Grid';

import {PtrnEstilosGenerales, PtrnPropsUtil} from '../patronUtils';
import {PtrnFlujoPasosProps} from './PtrnFlujoPasosTypes';
import {Divider} from '@mui/material';
import PtrnTitulo from '../components/PtrnTitulo';
import {PtrnStepperSecuencial} from '../components/PtrnStepper';
import {PtrnMainContentProps} from '../patronProps';
import PtrnContainerSimple from '../components/PtrnContainerSimple';
import {PtrnStepperRef} from '../components/PtrnStepper/PtrnStepperTypes';

//#region estilos
const useStyles = makeStyles<number>()((theme, maxHeightVhMain) => ({
   containerMainContent: PtrnEstilosGenerales.containerMainContent(maxHeightVhMain)
}));
//#endregion

const PtrnFlujoPasos = forwardRef<PtrnStepperRef, PtrnFlujoPasosProps & PtrnMainContentProps>(
   (
      {pasos, titulo, tituloXs, maxHeightVhMain, localizacion, children, inicializarEnUltimoPaso},
      ref
   ) => {
      //#region globales
      const {classes} = useStyles(maxHeightVhMain);
      const [pasoActivo, setPasoActivo] = useState(0);
      //#endregion

      //#region para retornos
      const tituloXsFinal = PtrnPropsUtil.getGridBrkpntValido(tituloXs, {default: 3});
      const gridPasosXs = 12 - tituloXsFinal;
      const ptrnRef = null;
      const idCompPrefix = 'ptrn-flu-pasos';
      //#endregion
      //#region retornos
      return (
         <PtrnContainerSimple id={`${idCompPrefix}-container`}>
            <Grid id={`${idCompPrefix}-grid-root`} container spacing={2}>
               <Grid
                  id={`${idCompPrefix}-grid-header`}
                  container
                  alignItems="center"
                  spacing={1}
                  item
                  xs={12}
               >
                  <Grid id={`${idCompPrefix}-grid-header-titulo`} item xs={tituloXsFinal}>
                     <PtrnTitulo>{titulo}</PtrnTitulo>
                  </Grid>
                  <PtrnStepperSecuencial
                     ref={ref}
                     id={`${idCompPrefix}-grid-header-pasos`}
                     xs={gridPasosXs}
                     justifyContent="flex-end"
                     steps={pasos}
                     activeStep={pasoActivo}
                     onActiveStepChange={(nuevo) => setPasoActivo(nuevo)}
                     ptrnRef={ptrnRef}
                     inicializarEnUltimoPaso={inicializarEnUltimoPaso}
                  />
               </Grid>
               <Grid item xs={12}>
                  <Divider />
               </Grid>
               <Grid
                  id={`${idCompPrefix}-grid-body-content`}
                  className={classes.containerMainContent}
                  container
                  alignItems="flex-start"
                  spacing={1}
                  item
                  xs={12}
               >
                  {children}
               </Grid>
            </Grid>
         </PtrnContainerSimple>
      );
      //#endregion
   }
);

export default PtrnFlujoPasos;
